/** Layer template schema + style (Maps API Template subset). */
export enum PropertyType {
  Text = 'text',
  Number = 'number',
  Boolean = 'boolean',
  Date = 'date',
  Choice = 'choice',
}

export interface PropertyChoice {
  readonly value: string;
  readonly label: string;
}

export type PropertyValue = string | number | boolean | null;

export interface PropertyDefinition {
  readonly name: string;
  readonly displayName: string;
  readonly type: PropertyType;
  readonly required: boolean;
  readonly readOnly: boolean;
  readonly defaultValue?: string | number | boolean | null;
  readonly choices?: readonly PropertyChoice[];
}

export const LAYER_LINE_STYLES = ['solid', 'dashed', 'dotted'] as const;

export type LayerLineStyle = (typeof LAYER_LINE_STYLES)[number];

export function isLayerLineStyle(value: string): value is LayerLineStyle {
  return LAYER_LINE_STYLES.some((style) => style === value);
}

export interface LayerStyle {
  readonly color: string;
  readonly lineStyle?: LayerLineStyle;
  readonly lineWeight?: number;
}

export const DEFAULT_LAYER_STYLE: LayerStyle = { color: '#ff0000' };

export interface LayerTemplate {
  readonly templateId?: string;
  readonly templateSeriesId?: string;
  readonly version?: number;
  readonly name?: string;
  readonly geometryType?: string;
  readonly properties: readonly PropertyDefinition[];
}
